import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import Inr from '@/components/Inr/index.vue';
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { BranchAgentService } from '@/services/branch-agent-service';
import { getQuery } from '@/utils';
import { getRanges } from '@/api/ranges';
import { getDealerCities, searchDealers } from '@/api/dealers';
import { getRangeWiseReports } from '@/api/orders-products-dispatches';
import { isAdmin, isSuperAdmin, isReadOnly, isBranchManager, isZonalManager } from '@/common';
import { getAdmins } from '@/api/admins';
import { BRANCH_MANAGER, ZONAL_MANAGER } from '@/constants/roles.constants';
import moment from 'moment';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import * as XLSX from 'xlsx';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    // define all variables used in this report
    this.branchList = [];
    this.dealerList = [];
    this.agentList = [];
    this.rangeList = [];
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.list = [];
    this.loggedInAdmin = null;
    this.isAgent = false;
    this.assignedBranches = [] || null;
    this.listLoading = false;
    this.downloadLoading = false;
    this.total = 0;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.showFilters = false;
    // false = Amount (default), true = Impact Value. Purely a display toggle -
    // the backend already returns both the amount and the "<field>Impact"
    // value for every range/total in one response, so switching this doesn't
    // need a refetch.
    this.showImpactValue = false;
    this.stateList = [];
    this.stateListLoading = false;
    this.cityList = [];
    this.cityListLoading = false;
    // listQuery
    this.listQuery = {
      page: 1,
      limit: 10,
      branchId: '',
      dealerId: '',
      rangeId: [],
      agentId: '',
      agentUserId: undefined,
      startDate: '',
      endDate: '',
      sort: 'dealerName,ASC',
      excludeBranches: false,
      stateId: undefined,
      cityId: undefined,
      'mappedAdmin.id': undefined,
      'zonalAdmin.id': undefined
    };
    // date picker custom shortcuts
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  // activated method
  async activated() {
    this.loggedInAdmin = AdminModule;
    this.listQuery.excludeBranches = true;
    // check if logged in user is Agent/Admin
    if (this.loggedInAdmin.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = this.loggedInAdmin.agentId;
      this.listQuery.agentUserId = this.loggedInAdmin.id;
    }
    // Assign branchId using BranchAgentService
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch agents for the assigned branchId
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    // set date range
    const currentMonth = this.$moment().month();
    const currentYear = this.$moment().year();
    // Determine financial year start and end
    const isFinancialYearStart = currentMonth >= 3; // April starts the financial year
    const startYear = isFinancialYearStart ? currentYear : currentYear - 1;
    const endYear = startYear + 1;
    this.dateRange = {
      start: this.$moment(`${startYear}-04-01`).format('YYYY-MM-01 12:00') + ' am',
      end: this.$moment(`${endYear}-03-31`).endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
    };
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    // fetch ranges
    await this.fetchRanges();
    await this.fetchSalesExecutiveManagers();
    await this.fetchZonalAdminManagers();
    // fetch main data
    await this.getList();
    this.getStateList();
  }
  // fetch main data
  async getList() {
    try {
      this.listLoading = true;
      // fetch data
      console.log('Fetching range wise reports with query:', this.listQuery);
      const data = await getRangeWiseReports(this.listQuery);
      this.list = data.data;
      this.total = +data.total;
      this.listLoading = false;
    } catch (error) {
      console.log(error);
      this.listLoading = false;
    }
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getDealerCityList(params) {
    const data = await getDealerCities(params);
    this.stateList = data.stateList;
    this.cityList = data.cityList;
  }
  // fetch dealer's list
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  // fetch ranges
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  isSalesExecutiveAdmin() {
    return isBranchManager();
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [BRANCH_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  // handle filter
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.getCityList(this.listQuery.stateId);
    } else {
      // empty city
      this.cityList = [];
      this.listQuery.cityId = undefined;
      this.listQuery.stateId = undefined;
    }
    if (!this.listQuery.cityId) {
      this.listQuery.cityId = undefined;
    }
    if (this.listQuery.dealerId) {
      const params = {
        dealerId: undefined
      };
      params.dealerId = this.listQuery.dealerId;
      this.getDealerCityList(params);
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  // Returns the amount or impact-value field for a row, depending on the
  // current toggle - both are always present in the response.
  displayValue(row, field) {
    return this.showImpactValue ? row[`${field}Impact`] : row[field];
  }
  handleValueModeChange() {
    // Re-sort by the equivalent field in the new mode (e.g. oliveSeries ->
    // oliveSeriesImpact) if currently sorted by one of the toggled columns,
    // so the active sort stays meaningful after switching.
    const [prop, order] = this.listQuery.sort.split(',');
    const isImpactProp = prop.endsWith('Impact');
    const baseProp = isImpactProp ? prop.slice(0, -'Impact'.length) : prop;
    const newProp = this.showImpactValue ? `${baseProp}Impact` : baseProp;
    if (newProp !== prop) {
      this.listQuery.sort = `${newProp},${order}`;
      this.handleFilter();
    }
  }
  sortChange(data) {
    let {
      prop,
      order
    } = data;
    if (prop) {
      if (this.showImpactValue && !prop.endsWith('Impact')) {
        prop = `${prop}Impact`;
      }
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin() || isReadOnly();
  }
  getAdminByRole(mappedAdmins, roleName) {
    try {
      if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
      const admin = mappedAdmins.find(a => {
        var _a$roles;
        return a === null || a === void 0 || (_a$roles = a.roles) === null || _a$roles === void 0 ? void 0 : _a$roles.some(r => (r === null || r === void 0 ? void 0 : r.name) === roleName);
      });
      return admin ? admin.fullName : '';
    } catch {
      return '';
    }
  }
  async handleExcelDownload() {
    try {
      this.downloadLoading = true;
      // Fetch all pages for export
      const allDataQuery = {
        ...this.listQuery,
        page: 1,
        limit: 100000
      };
      const data = await getRangeWiseReports(allDataQuery);
      const rows = data.data || [];
      const excelData = rows.map(row => ({
        Dealer: row.dealerName,
        Agent: row.aName,
        State: row.stateName,
        'Olive Series': this.displayValue(row, 'oliveSeries'),
        'Oura Series': this.displayValue(row, 'ouraSeries'),
        'Deluxe Series': this.displayValue(row, 'deluxeSeries'),
        'MCB Series': this.displayValue(row, 'mcbSeries'),
        'Lyfe Series': this.displayValue(row, 'lyfeSeries'),
        'Viva Series': this.displayValue(row, 'vivaSeries'),
        'Curvy Series': this.displayValue(row, 'curvySeries'),
        'I-Connect Series': this.displayValue(row, 'iconnectSeries'),
        'Epic Series': this.displayValue(row, 'epicSeries'),
        'Total Sales': this.displayValue(row, 'totalSales'),
        'Branch Manager': this.getAdminByRole(row.mappedAdmins, 'Branch Manager'),
        'Zonal Manager': this.getAdminByRole(row.mappedAdmins, 'Zonal Manager')
      }));
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Range Wise Report');
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([wbout], {
        type: 'application/octet-stream'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'range-wise-report.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadLoading = false;
    } catch (error) {
      this.downloadLoading = false;
      console.log(error);
      this.$message.error('Error downloading Excel');
    }
  }
};
default_1 = __decorate([Component({
  name: 'RangeWiseReportList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;